<template>
  <article
    class="painel-info"
    :style="{
      backgroundColor: backgroundColor,
      borderColor: borderColor
    }"
  >
    <v-icon
      :color="iconColor"
      size="24"
    >
      {{ icon }}
    </v-icon>
    <span
      class="painel-info-text"
      :style="{ color: textColor }"
    >
      {{ text }}
    </span>
  </article>
</template>

<script>
export default {
  name: 'InfoPainel',
  props: {
    icon: {
      type: String,
      required: true,
      default: 'mdi-information',
    },
    text: {
      type: String,
      required: true,
      default: '',
    },
    textColor: {
      type: String,
      default: '#000000',
    },
    iconColor: {
      type: String,
      default: '#000000',
    },
    borderColor: {
      type: String,
      default: '#cccccc',
    },
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
  },
}
</script>

<style scoped>
  .painel-info {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px;
    border: 1px solid;
    border-radius: 5px;
  }
  .painel-info-text {
    font-size: 12px;
    font-weight: 500;
  }
</style>
